import { db } from "../firebase-config";
import { collection, doc, addDoc, updateDoc, deleteDoc } from "firebase/firestore";

export const addLocation = async (organization, locationData) => {
    try {
        const locationsRef = collection(db, "organizations", organization, "locations");
        await addDoc(locationsRef, { ...locationData });
        return { success: true, error: null };
    } catch (error) {
        console.error("Failed to add location:", error);
        return { success: false, error: error.message || "Failed to add location" };
    }
};

// Update an existing inventory location
export const updateLocation = async (organization, locationData, locationId) => {
    try {
        const locationDoc = doc(db, "organizations", organization, "locations", locationId);
        await updateDoc(locationDoc, locationData);
        return { success: true, error: null };
    } catch (error) {
        console.error("Failed to update location:", error);
        return { success: false, error: error.message || "Failed to update location" };
    }
};

export const deleteLocation = async (organization, locationId) => {
    try {
        const locationRef = doc(db, "organizations", organization, "locations", locationId);
        await deleteDoc(locationRef);
        return { success: true, error: null };
    } catch (error) {
        console.error("Error deleting location:", error);
        return { success: false, error: error.message || 'Failed to delete location' };
    }
};